import { Component, Input } from '@angular/core';
import { SharedModule } from '@/app/shared/shared.module';
import { MixpanelTrackerService } from '@/app/core/analytics';
import { PlantationService } from '@/app/core/services/plantation.service';
import { NoteViewModel } from '@/app/proxy/proxies';

type MapType = 'apple' | 'google' | 'yandex';

@Component({
  selector: 'app-crop-health-note-get-direction',
  imports: [SharedModule],
  templateUrl: './crop-health-note-get-direction.component.html',
  styleUrl: './crop-health-note-get-direction.component.less',
})
export class CropHealthNoteGetDirectionComponent {
  @Input() coordinates: {
    lat: number;
    lng: number;
  };
  @Input() note: NoteViewModel;
  selected: MapType;

  constructor(
    private mixpanelTracker: MixpanelTrackerService,
    private plantationService: PlantationService,
  ) {}

  private trackServicesNoteDirectionRequested(): void {
    if (!this.note || !this.plantationService.selectedPlantation || !this.selected) {
      return;
    }

    const land = this.plantationService.selectedLand;
    const enterpriseId = land?.enterpriseId || this.plantationService.enterpriseId;
    const enterprise = this.plantationService.originalResult?.find((item) => item.id === enterpriseId);
    const problemType = this.note.noteTags?.map((item) => item.name).filter(Boolean).join(', ');

    const mapApp =
      this.selected === 'google'
        ? 'Google Maps'
        : this.selected === 'apple'
          ? 'Apple Maps'
          : 'Yandex Maps';

    this.mixpanelTracker.trackServicesNoteDirectionRequested({
      'problem type': problemType || undefined,
      'description entered': !!this.note.noteContent?.trim(),
      'photo added': !!this.note.fileList?.length,
      'plantation id': this.plantationService.selectedPlantation.id,
      'plantation name': this.plantationService.selectedPlantation.name,
      'land id': land?.id,
      'land name': land?.name,
      'enterprise id': enterpriseId,
      'enterprise name': enterprise?.enterpriseName,
      'map app': mapApp,
    });
  }

  getDirection() {
    this.trackServicesNoteDirectionRequested();

    const { lat, lng } = this.coordinates;
    let url: string;

    if (this.selected == 'apple') {
      url = `https://maps.apple.com/?daddr=${lat},${lng}&dirflg=d`;
    }
    if (this.selected == 'google') {
      url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    }
    if (this.selected == 'yandex') {
      url = `https://yandex.com/maps/?rtext=~${lat},${lng}&rtt=auto`;
    }
    window.open(url, '_blank');
  }
}
